import { useContext } from 'react'
import { MixpanelContext } from '../contexts/MixpanelContext'

// ----------------------------------------------------------------------

export enum MixpanelPropertyName {
	EventType = 'EventType',
}

export enum MixpanelEvents {
	ConfiguredToken = 'ConfiguredToken',
	CustomTokenClick = 'CustomTokenClick',
	SpaceClick = 'SpaceClick',
	FeedNextPage = 'FeedNextPage',
	FeedFirstPage = 'FeedFirstPage',
	JoinWWhitelistButton = 'JoinWhitelistButton',
	Like = 'Like',
	Share = 'Share',
	AddToInventory = 'AddToInventory',
	ChangeJob = 'ChangeJob',
	HoverOverPFP = 'HoverOverPFP',
	HoverOverPromotedItem = 'HoverOverPromotedItem',
	HoverOverSpace = 'HoverOverSpace',
	PageView = 'PageView',
	MailChimp = 'MailChimp',
	Back = 'Back',
	ShowComments = 'ShowComments',
	PasteUrlForImport = 'PasteUrlForImport'
}

export enum MixpanelParentComponents {
	PostCard = 'PostCard',
	PostCardComment = 'PostCardComment',
	ActionCard = 'ActionCard',
	ThoughtCard = 'ThoughtCard',
	PromotedItemCard = 'PromotedItemCard',
	BuyNowCarousel = 'BuyNowCarousel',
	AboutPanel = 'AboutPanel',
	PFPCallout = 'PFPCallout',
	PromotedItemCallout = 'PromotedItemCallout',
	SpaceCallout = 'SpaceCallout',
	Header = 'Header'
}

export enum MixpanelClickLocations {
	Avatar = 'Avatar',
	Name = 'Name'
}

export enum MixpanelEventTypes {
	Interaction = 'Interaction',
	Event = 'Event',
}

export interface IMixpanelSource {
	parentComponent: MixpanelParentComponents
	event?: MixpanelEvents
}

// ----------------------------------------------------------------------

const useMixpanel = () => {
	const context = useContext(MixpanelContext)

	if (!context) throw new Error('Mixpanel context must be use inside MixpanelProvider')

	return context
}

export default useMixpanel
